import { getGeoEntityByISO3 } from "@/models/GeoEntity.ts";

// Geolocation type holds lat/lng of a location
// export default class GeoLocation {
//   lat: number = 0;
//   lng: number = 0;
// }

export interface Location {
  _id?: number;
  name?: string;
  latlng: number[];
}

export interface Locations {
  centroid: number[];
  locations: Location[];
}

export const emptyLocation = {
  name: "",
  latlng: [],
};

export function updateCentroid(locations: Locations, iso3: string = "") {
  let centroid = [0, 0];
  const country = getGeoEntityByISO3(iso3);
  if (!!country && !!country.centroid) {
    centroid = country.centroid;
  }

  if (locations.locations.length > 0) {
    for (const location of locations.locations) {
      if ("latlng" in location) {
        const [lat, lng] = location.latlng;
        centroid[0] += lat;
        centroid[1] += lng;
      }
    }
    centroid[0] /= locations.locations.length;
    centroid[1] /= locations.locations.length;
  }
  locations.centroid = centroid;
}

export interface MapMarker {
  id?: number;
  position: { lat: number, lng: number };
}
